/**
 * Creates hierarchical menu based on WordPress menu.
 * @link https://www.wpgraphql.com/docs/menus/#hierarchical-data
 */
import * as React from "react";

/**
 * Internal dependencies.
 */
import LangMenu from '§/src/components/menus/lang-menu';
import BaseMenu from '§/src/components/menus/base-menu';
import SocialMenu from '§/src/components/menus/social-menu';
import './_top-nav.scss';


const TopNav = ( props ) => {
  const { lang, langReplace, langMenu, topMenu, socialMenu, general } = props;

  return (
    <div id="top-navbar" className="d-none d-lg-flex">
      <div className="container-xxl">
        <LangMenu lang={lang} langReplace={langReplace} wpMenu={ langMenu } general={ general } className="dropdown" id="lang-top" buttonClass="btn-dark" theme="dropdown-menu-dark"></LangMenu>
        <BaseMenu wpMenu={ topMenu } id="menu-top" className="" buttonClass="btn btn-sm btn-link text-light"></BaseMenu>
        <SocialMenu wpMenu={ socialMenu }></SocialMenu>
      </div>
    </div>

  )
}

export default TopNav
